import MilitaryTechIcon from "@mui/icons-material/MilitaryTech";
import { LoyaltyOverviewSection } from "Components/Loyalty/Shared/Overview/LoyaltyOverviewSection";
import { RulesLink } from "Components/Loyalty/Valor/RulesLink";
import { Resources } from "Translations/Resources";

const OVERVIEW = Resources.Pages.Content.Valor.Overview;

export const OverviewSection = () => (
  <LoyaltyOverviewSection
    config={{
      pointsResources: OVERVIEW.Points,
      pointsIcon: <MilitaryTechIcon />,
      payoutResources: OVERVIEW.Payout,
      rewardsResources: OVERVIEW.Rewards,
      myShareResources: OVERVIEW.MyShare,
      RulesLink: <RulesLink />,
    }}
  />
);
